import classNames from "classnames";
import React, { useCallback, useState } from "react";
import TextInput from "shared/@forms/TextInput";
import styles from "./index.module.css";

const defaultPattern = "^-?\\d{0,}[.]?\\d{0,2}$";

const MoneyInput = ({
  value,
  onChange,
  className,
  pattern = defaultPattern,
  ...props
}) => {
  const [editValue, setEditValue] = useState(value?.toString() ?? "0");

  const handleChange = useCallback(
    (e) => {
      setEditValue(e.target.value);

      const isValid = e.target.validity.valid;

      console.log({
        value: e.target.value,
        validity: e.target.validity,
        parsed: Number(e.target.value),
        pattern,
        isValid,
      });

      if (isValid) {
        const value = Number(e.target.value);
        onChange(value);
      }
    },
    [pattern, editValue]
  );

  return (
    <div className={styles.container}>
      <span className={styles.symbol}>{props.symbol ?? "$"}</span>

      <TextInput
        placeholder={props.placeholder ?? "Enter Amount"}
        {...props}
        value={editValue}
        onChange={handleChange}
        className={classNames(styles.input, className)}
        pattern={pattern.toString()}
      />
    </div>
  );
};

export default MoneyInput;
